<template>
  <article class="m-card-element m-card-element-design-2 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <img
        v-if="satelite.imagen"
        :alt="satelite.titulo"
        :src="satelite.imagen"
      >
      <img
        v-else
        :alt="satelite.titulo"
        src="@/assets/img/ds2.png"
      >

      <h5>
        {{ $t('mEditionBillingSatellites.card.type') }}
      </h5>

      <h2 class="m-card-element-design-2-name">
        {{ satelite.titulo }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="satelite.activo"
          class="text-color-success"
        >
          {{ $t('mEditionBillingSatellites.card.activo') }}
        </h3>
        <h3
          v-else
          class="text-color-black-35"
        >
          {{ $t('mEditionBillingSatellites.card.inactivo') }}
        </h3>
      </div>

      <span class="margin-left-auto font-size-small text-color-black-45">
        <i class="fas fa-eye font-size-small"></i>
        {{ $t('mEditionBillingSatellites.card.detail') }}
      </span>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingSatellitesCard',

  props: {
    satelite: Object
  }
}
</script>
